import { Injectable } from '@angular/core';
import { MapConstants } from 'src/app/utils/map.constant';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup';
// import { ObservedWeatherDataService } from './observed-weather-data.service';
import { UtilsSharedModule } from '../../shared/utils/utils/utils.module';
import { UtilsService } from 'src/app/utils/utils.service';
import { ConstantsModule } from '../../shared/constants/constants.module';
import { arrayMax, dateFormat } from 'highcharts';
import { delay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isNullOrUndefined } from 'util';
import { ActivatedRoute, Router } from '@angular/router';
// import { CQLFILTER_MAPPING, LOCTYPE_LAYER_MAPPING } from './observed-rainfall/observed-rainfall-map-data/observed-rainfall-map.constant';
// import { CQLFILTER_MAPPING,LOCTYPE_LAYER_MAPPING } from './rainfall-actual-map/rainfall-actual-map-data/rainfall-actual-map.constants';
import { CQLFILTER_MAPPING,LOCTYPE_LAYER_MAPPING } from './rainfall-actual-map-data/rainfall-actual-map.constants';
// import { ObservedRainfallDataService } from './observed-rainfall/observed-rainfall-data.service';
import { RainfallActualDataService } from './rainfall-actual-data.service';
import { TaskManagerComponent } from './task-manager/task-manager.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class RainfallActualMapService {
  stateBoundary: any;
  basinBoundary: any;
  stateName: any;
  stateUUID: any;
  LayerGroup = new L.LayerGroup();
  mapObj: any;
  gisMapComp: any;
  markerLayer: any;

  constructor(
    public observedWeatherDataService: RainfallActualDataService,
    private utilsShared: UtilsSharedModule,
    private constants: ConstantsModule,
    private utils: UtilsService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    
    private rainfallDataService : RainfallActualDataService
  ) {
    const url = this.router.url.split('/');
    this.stateName = ProjConstants.IDTOCOUNTRYNAMEMAPPING[url[url.length - 1]];
    this.stateUUID = ProjConstants.IDTOUUIDMAPPING[url[url.length - 1]];
  }

  public createLayer(layer, gis) {
    // console.log("Entered");
    this.gisMapComp = gis
    this.mapObj = gis.map
    if (layer.serviceType == 'WmsLayer') {
      return this.createWmsLayer(layer, gis);
    }
    if (layer.serviceType == 'VectorLayer') {
      return this.createVectorLayer(layer, gis);
    }
    if (layer.serviceType == 'HeatMap') {
      return this.createHeatMapLayer(layer, gis);
    }
    if (layer.serviceType == 'Raster') {
      return this.createRasterLayer(layer, gis);
    }
    if (layer.serviceType == 'CroppedHeatMap') {
      return this.createCroppedHeatMapLayer(layer, gis);
    }
    if (layer.serviceType == 'GeoJsonMarker') {
      return this.createGeoJsonLayer(layer, gis);
    } else {
      return new Promise((resolve, reject) => {
        resolve(true);
      });
    }
  }

  createVectorLayer(layer, gis) {
    const options = {
      interactive: true,
      rendererFactory: {},
      opacity: 1,
      minZoom: 5,
      maxZoom: 18,
      pane: 'district',
      visible: true,
      transparent: true,
      vectorTileLayerStyles: {},
      getFeatureId: {},
    };
    options['rendererFactory'] = (L as any).canvas.tile;
    options['getFeatureId'] = function (feature) {
      return feature.properties.UUID;
    };
    options['vectorTileLayerStyles'][layer.layerName] = function (
      properties,
      zoom
    ) {
      var style = {
        opacity: 0,
      };
      return style;
    };
    const url =
      MapConstants.GEOSERVER_WMTS_URL + '&layer=HEATWAVE:' + layer.layerName;
    layer['layer'] = (L as any).vectorGrid.protobuf(url, options);
    let dbClick = 0;
    gis.map.on({
      dblclick: (e: L.LayerEvent) => {
        {
          dbClick = 1;
        }
      },
    });

    layer['layer'].on({
      click: async (e: L.LayerEvent) => {
        // {
        //   await delay(300);
        //   if (dbClick > 0) {
        //     await delay(1000);
        //     dbClick = 0;
        //     return;
        //   }
        //   const postData = {};
        //   postData['source'] = 'IMD_SHORT_RANGE';
        //   postData['latitude'] = e.latlng.lat;
        //   postData['longitude'] = e.latlng.lng;
        //   if (gis.adminSelected) {
        //     postData['view'] = 'Admin';
        //   } else {
        //     postData['view'] = 'Basin';
        //   }
        //   postData['forecastLength'] = gis.forecastLength;
        //   const apiParams = {};
        //   apiParams['url'] = 'BOTTOMBARDATA';
        //   apiParams['postData'] = postData;
        //   this.utils.setLatLong(apiParams['postData']);
        //   this.createPopUp(e.latlng, gis);
        //   gis.openBottomBar(apiParams, 'actual');
        //   gis.selectedLocation = e.layer.properties[layer.locationName];
        // }
        let properties = e.layer.properties;
            if(gis.map.getZoom() >= 5 && gis.map.getZoom() < 7){
             this.stateUUID = properties.State_UUID
            //  gis.map.setView([properties.Latitude,properties.Longitude],7)
            const locClick = {
              loc: properties.State_Name,
              centroid: { lat: properties.Latitude, lon: properties.Longitude },
              zoomLevel: 8,
              uuid: properties.State_UUID
            };
            locClick['locType'] = 'State'
            this.utils.districtClicked.next(locClick);
            //  this.utils.setStateClicked(properties.State_UUID)     // to get the stateUUID to emit state data
             this.utils.setStateClickedName(properties)            // to get the name in breadcrumb
             // if(properties.State)
           }
           if(gis.map.getZoom() >= 7 && gis.map.getZoom() < 10 && (properties.State_UUID == this.stateUUID || properties.State_UUID == gis.urlParams.locuuid)){
            const locClick = {
              loc: properties.Dist_Name,
              centroid: { lat: properties.Latitude, lon: properties.Longitude },
              zoomLevel: 11,
              uuid: properties.UUID
            };
            locClick['locType'] = 'District'
            this.utils.districtClicked.next(locClick);
            //  gis.map.setView([properties.Latitude,properties.Longitude],9)
            //  this.utils.setDistrictsClicked(properties.UUID)       //to get the DistrictUUID in order to show mandals
            }
            else {
              gis.map.setView([properties.Latitude,properties.Longitude])
              this.utils.setMandalClicked(properties.UUID)         //to zoom in to the mandal

           }
      },
    });
    return layer;
  }

  createWmsLayer(layer, gis) {
    const options = {
      layers: layer.layerName,
      opacity: 1,
      format: 'image/png',
      visible: true,
      transparent: true,
      pane: layer.zIndex ? layer.zIndex : 'district',
      fadeAnimation: false,
      // attribution: "<a href = 'https://mausam.imd.gov.in/'> Data Source : IMD </a>"
    };
    if (layer.cql_filter != null && layer.cql_filter != undefined) {
      options['cql_filter'] = layer.cql_filter;
    }
    if (layer.pane != null && layer.pane != undefined) {
      options['pane'] = layer.pane;
    }
    if (layer.minZoom != null && layer.minZoom != undefined) {
      options['minZoom'] = layer.minZoom;
    }
    if (layer.stateName != null && layer.stateName != undefined) {
      options['viewParams'] = 'stateName:' + layer.stateName;
    }
    if (layer.env != null && layer.env != undefined) {
      options['env'] = layer.env;
    }
    if(layer.styles){
      options['styles'] = layer.styles
    }
    // if (layer.cql_filter != null && layer.cql_filter != undefined) {
    //   options['cql_filter'] = layer.cql_filter;
    // }
    const url = MapConstants.GEOSERVER_WMS_URL;
    layer['layer'] = (L as any).tileLayer.wms(url, options);
    return layer;
  }

  createHeatMapLayer(layer, gis) {
    const layerPromise = new Promise((resolve, reject) => {
      const options = {
        opacity: 1,
        pane: 'heatMap',
        minZoom: 6,
        maxZoom: 18,
      };
      // let bounds = {
      //   y_min: 12.6,
      //   x_min: 76.75,
      //   y_max: 19.2,
      //   x_max: 84.8,
      // };
      // if (gis.urlParams.view == 'BASIN') {
      //   bounds = {
      //     y_min: 11.15,
      //     x_min: 73.3,
      //     y_max: 22.7,
      //     x_max: 85.25,
      //   };
      // }
      // console.log(layer.url);
      gis.showThrobber = true
      console.log("%%%%% checkkkkkkkkkkk",layer.url);

      if (layer.url != null && layer.url != undefined) {
        console.log("%%%%%",layer.url);
        this.observedWeatherDataService
          .getHeatMapData(layer.url, layer.postData)
          .subscribe((data) => {
            if (data != null && data != undefined && data['ACTUAL'] != null) {
              // const imgBounds = new L.LatLngBounds(
              //   new L.LatLng(bounds['y_min'], bounds['x_min']),
              //   new L.LatLng(bounds['y_max'], bounds['x_max'])
              // );
              let obj = this.setMapData(layer.heatMapImageBound)
              const imgBounds = this.getImageBounds(obj['bounds']);
              const imageLayer = L.imageOverlay(data['ACTUAL'], imgBounds, options);
              layer['layer'] = imageLayer;
            }
            resolve(layer);
          });
      }
    });
    return layerPromise;
  }

  createRasterLayer(layer, gis) {
    console.log()
    const layerPromise = new Promise((resolve, reject) => {
      const options = {
        opacity: 1,
        pane: 'heatMap',
        minZoom: 6,
        maxZoom: 18,
      };
      gis.showThrobber = true
      if (layer.url != null && layer.url != undefined) {
        this.observedWeatherDataService
          .getHeatMapData(layer.url, layer.postData)
          .subscribe((data) => {
            if (data != null && data != undefined && data['ACTUAL'] != null) {
              let obj = this.setMapData(layer.heatMapImageBound)
              console.log(obj,"obj123");
              
              const imgBounds = this.getImageBounds(obj['bounds']);
              const imageLayer = L.imageOverlay(data['ACTUAL'], imgBounds, options);
              layer['layer'] = imageLayer;
            }
            resolve(layer);
          });
      }
    });
    return layerPromise;
  }

  setMapData(data) {
    let obj = {};
    let imageUrl = {};
    let imageBounds = [];
    // for (let block of Object.keys(data)) {
      // for (let property of Object.keys(data[block])) {
        // imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data['southWest']['latitude']);
        latlongs.push(data['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data['northEast']['latitude']);
        latlongs.push(data['northEast']['longitude']);
        imageBounds.push(latlongs);
      // }
      // obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    // }
    return obj;
  }

  getImageBounds(imageBounds) {
    const anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]]);
    anchors.push([imageBounds[1][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[0][1]]);
    return anchors;
  }

  createCroppedHeatMapLayer(layer, gis) {
    // console.log("Entered");
    const layerPromise = new Promise((resolve, reject) => {
      const options = {
        opacity: 1,
        pane: 'heatMap',
        minZoom: 6,
        maxZoom: 15,
      };
      let bounds = {
        y_min: 12.6,
        x_min: 76.75,
        y_max: 19.2,
        x_max: 84.8,
      };
      if (gis.urlParams.view == 'BASIN') {
        bounds = {
          y_min: 11.15,
          x_min: 73.3,
          y_max: 22.7,
          x_max: 85.25,
        };
      }
      const anchors = [
        [bounds.y_max, bounds.x_min],
        [bounds.y_max, bounds.x_max],
        [bounds.y_min, bounds.x_max],
        [bounds.y_min, bounds.x_min],
      ];
      this.getShapeBoundaryLayers(
        gis.urlParams.view,
        true,
        layer.stateName
      ).then((data) => {
        // console.log(data);
        if (data != null) {
          options['clip'] = data;
        }
        if (layer.url != null && layer.url != undefined) {
          this.observedWeatherDataService
            .getHeatMapData(layer.url, layer.postData)
            .subscribe((data) => {
              // console.log(data);
              if (data != null && data != undefined) {
                if (!isNullOrUndefined(data['MAX'])) {
                  data = data['MAX'];
                } else if (!isNullOrUndefined(data['MIN'])) {
                  data = data['MIN'];
                }
                // console.log("Final");
                // layer['layer'] = L.imageTransform('assets/imgs/temperature-temp100.png',anchors,options);
                layer['layer'] = L.imageTransform(data, anchors, options);
                // layer['layer'].addTo(gis.map);
                // gis.map.removeLayer(layer['layer'])
              }
              resolve(layer);
            });
        }
      });
    });
    return layerPromise;
  }

  createPopUp(latlng, gis) {
    const myIcon = L.divIcon({
      className: 'icon-dot',
      html: '<div class="pulsating-icon repeat"></div>',
    });
    const markerOptions = {
      icon: myIcon,
      pane: 'popUp',
    };
    if (
      gis.clickedLocationMarker != null &&
      gis.clickedLocationMarker != undefined
    ) {
      gis.clickedLocationMarker.unbindTooltip();
      gis.clickedLocationMarker.bindTooltip(gis.clickedLocationTooltip);
      gis.clickedLocationMarker = null;
    }
    if (gis.map.hasLayer(gis.marker)) {
      gis.map.removeLayer(gis.marker);
    }
    gis.marker = L.marker([latlng.lat, latlng.lng], markerOptions).addTo(
      gis.map
    );
  }

  getShapeBoundaryLayers(view, clip, stateName) {
    const shapeBoundary = new Promise((resolve, reject) => {
      if (clip == false) {
        resolve(null);
      }
      if (view == 'ADMIN') {
        if (this.stateBoundary == null || this.stateBoundary == undefined) {
          const layerName =
            MapConstants.GEOSERVER_WORKSPACE_NAME +
            ':' +
            ProjConstants.STATE_TO_LAYERTYPE_NAME[
              stateName + '_STATE_BOUNDARY'
            ];
          const boundaryURL =
            MapConstants.GEOJSON_LAYER_URL +
            '&typeName=' +
            layerName +
            '&viewParams=stateName:' +
            stateName;
          this.http.get(boundaryURL).subscribe((data) => {
            this.stateBoundary = data['features'][0]['geometry'];
            resolve(this.stateBoundary);
          });
        } else {
          resolve(this.stateBoundary);
        }
      } else {
        if (this.basinBoundary == null || this.basinBoundary == undefined) {
          const layerName =
            MapConstants.GEOSERVER_WORKSPACE_NAME +
            ':' +
            ProjConstants.STATE_TO_LAYERTYPE_NAME[
              stateName + '_BASIN_BOUNDARY'
            ];
          const boundaryURL =
            MapConstants.GEOJSON_LAYER_URL +
            '&typeName=' +
            layerName +
            '&viewParams=stateName:' +
            ProjConstants.STATENAME;
          this.http.get(boundaryURL).subscribe((data) => {
            this.basinBoundary = data['features'][0]['geometry'];
            resolve(this.basinBoundary);
          });
        } else {
          resolve(this.basinBoundary);
        }
      }
    });
    return shapeBoundary;
  }

  createGeoJsonLayer(layer, gis) {
    const filter = layer.Filter;
    const promise = new Promise((resolve, reject) => {
      this.observedWeatherDataService
        .getGeoJsonLayerData(layer.url, filter)
        .subscribe((geodata) => {
          // console.log("GeoJsonData",geodata);
          this.observedWeatherDataService
            .getdataGis(layer.formattingUrl, layer.postData)
            .subscribe((data) => {
              const formattedData = this.observedWeatherDataService.formatdata(
                layer,
                geodata,
                data
              );
              layer['layer'] = this.addMarkerLayer(
                formattedData,
                layer,
                gis.map,
                gis.urlParams
              );
              resolve(layer);
            });
        });
    });
    return promise;
  }

  addMarkerLayer(geoJsonData: any, layer: string, map: L.Map, urlParams) {
    const vm = this;

    const geoJsonLayer = L.geoJSON(geoJsonData, {
      style(feature) {
        return this.stylingforGeoJson(feature, layer['LayerName']);
      },

      pointToLayer(feature, latlng) {
        if (layer['PointToLayer']) {
          return vm[layer['PointToLayer']](feature, latlng, map, urlParams);
        }
      },
      onEachFeature(feature, latlng) {
        if (layer['OnEachFeature']) {
          return this[layer['OnEachFeature']](feature, latlng, map);
        }
      },
      pane: 'marker',
    });

    return geoJsonLayer;
  }

  getmandalcolor(value) {
    // if (parseFloat(value) > parseFloat('60')) {return '#0099ff';}
    // else if (parseFloat(value) > parseFloat('20') && parseFloat(value) < parseFloat('39')) {return '#b9e5fb';}
    // else if (parseFloat(value) > parseFloat('40') && parseFloat(value) < parseFloat('59')) {return '#66ccff';}
    // else if (parseFloat(value) > parseFloat('-19') && parseFloat(value) < parseFloat('19')) {return '#90ed7d'}
    // else if (parseFloat(value) < -20 && parseFloat(value) > -39) {return '#e80d0d';}
    // else if (parseFloat(value) < -40 && parseFloat(value) > -59) {return '#ee7676';}
    // else if ( parseFloat(value) < -60 && parseFloat(value) > -79){return '#e9e910';}
    // else if ( parseFloat(value) < -80 && parseFloat(value) > -99) {return '#fafaaf';}
    // else if (parseFloat(value) == -100) {return '#b3b1b1';}
    if (value >= 60) {
      return '#0099ff';
    } else if (value >= 40 && value < 60) {
      return '#66ccff';
    } else if (value >= 20 && value < 40) {
      return '#b9e5fb';
    } else if (value >= -19 && value < 20) {
      return '#90ed7d';
    } else if (value < -19 && value > -40) {
      return '#e80d0d';
    } else if (value <= -40 && value > -60) {
      return '#ee7676';
    } else if (value <= -60 && value > -80) {
      return '#e9e910';
    } else if (value <= -80 && value > -99) {
      return '#fafaaf';
    } else if (value == -100) {
      return '#b3b1b1';
    } else {
      return '#ffffff';
    }
  }

  stylingforGeoJson(feature, layerName) {
    return;
  }

  Rainfall_Sensrs_pointToLayer(feature, latlng, map, urlParams) {
    // console.log(urlParams);
    //  console.log("feature.properties ::",feature.properties);

    var outerCircleOptions = {
      stroke: true,
      fill: true,
      color: '#212121',
      weight: 0.5,
      fillColor: '#000000',
      fillOpacity: 1,
      radius: 3,
      pane: 'marker',
    };

    const concentricCircleLayer = new L.LayerGroup();

    const params = urlParams;
    const startDate =
      params['sDate'] || this.utilsShared.getModelDateFromDate(new Date());
    const endDate =
      params['eDate'] || this.utilsShared.getModelDateFromDate(new Date());
    const format =
      params['format'] || this.constants.DATEPICKER_DATE_FORMAT.DAY;
    const noOfDays =
      1 +
      this.utilsShared.getNumberOfDaysBetweenTwoModelDates(
        startDate,
        endDate,
        format
      );
    ///////
    // console.log("noOfDays ::",noOfDays);
    let range = 0;
    if (noOfDays < 17) {
      range = 0;
    } else if (noOfDays >= 17 && noOfDays <= 301) {
      range = 1;
    } else {
      range = 2;
    }

    const markerData = feature.properties;
    if (markerData) {
      outerCircleOptions.radius = this.getCircleMarkerRadius(
        map.getZoom(),
        2.5
      );
      // outerCircleOptions.fillColor = '#00127e';
      outerCircleOptions.fillColor = '#b3b3b3';
      if (feature.properties['actual']) {
        outerCircleOptions.fillColor = this.getRainfallSensorColor(
          feature.properties['actual'],
          range
        );
      }
      outerCircleOptions['properties'] = feature.properties;
      const outerCircle = L.circleMarker(latlng, outerCircleOptions);
      concentricCircleLayer.addLayer(outerCircle);
      outerCircle.on({
        click: (e: L.LayerEvent) => {
          // console.log(urlParams);
          this.showStationLevelData(e.target.options.properties, urlParams);
        },
      });

      map.on({
        zoomend: (e: L.LeafletEvent) => {
          outerCircle.setRadius(this.getCircleMarkerRadius(map.getZoom(), 2.5)); // add this line to change the style
        },
      });
    }
    return concentricCircleLayer;
  }

  showStationLevelData(properties, oldUrlParams) {
    // console.log('properties ::',properties);
    // console.log('properties ::',oldUrlParams);

    const urlParams = JSON.parse(JSON.stringify(oldUrlParams));
    if (oldUrlParams['component']) {
      const locname = properties['gau_st'];
      const locuuid = properties['loc_uuid'];
      Object.assign(urlParams, {
        locname,
        loctype: 'STATION',
        locuuid,
        mapOnClickParams: true,
        cType: 'STATION',
      });
      this.utils.setQueryParams(urlParams);
    }
    // else{

    // console.log(" on click kkkkkkkkkkkkkkkkkkk ::",urlParams);

    // this.router.navigate([url, urlParams]);}
  }

  getRainfallSensorColor(value, range) {
    if (range == 0) {
      if (parseFloat(value) > parseFloat('600')) {
        return '#9A98FF';
      } else if (
        parseFloat(value) >= parseFloat('350') &&
        parseFloat(value) < parseFloat('599')
      ) {
        return '#9BC2FF';
      } else if (
        parseFloat(value) >= parseFloat('250') &&
        parseFloat(value) < parseFloat('350')
      ) {
        return '#97F5FD';
      } else if (
        parseFloat(value) >= parseFloat('200') &&
        parseFloat(value) < parseFloat('250')
      ) {
        return '#BDFEE1';
      } else if (
        parseFloat(value) >= parseFloat('150') &&
        parseFloat(value) < parseFloat('200')
      ) {
        return '#E6FEB6';
      } else if (
        parseFloat(value) >= parseFloat('100') &&
        parseFloat(value) < parseFloat('150')
      ) {
        return '#FFEEA1';
      } else if (
        parseFloat(value) >= parseFloat('50') &&
        parseFloat(value) < parseFloat('100')
      ) {
        return '#FFC298';
      } else if (
        parseFloat(value) >= parseFloat('0') &&
        parseFloat(value) < parseFloat('50')
      ) {
        return '#FC9994';
      } else {
        return '#ffffff';
      }
    } else if (range == 1) {
      if (parseFloat(value) > parseFloat('3500')) {
        return '#9A98FF';
      } else if (
        parseFloat(value) >= parseFloat('3000') &&
        parseFloat(value) < parseFloat('3500')
      ) {
        return '#9BC2FF';
      } else if (
        parseFloat(value) >= parseFloat('1500') &&
        parseFloat(value) < parseFloat('3000')
      ) {
        return '#97F5FD';
      } else if (
        parseFloat(value) >= parseFloat('900') &&
        parseFloat(value) < parseFloat('1500')
      ) {
        return '#BDFEE1';
      } else if (
        parseFloat(value) >= parseFloat('700') &&
        parseFloat(value) < parseFloat('900')
      ) {
        return '#E6FEB6';
      } else if (
        parseFloat(value) >= parseFloat('500') &&
        parseFloat(value) < parseFloat('700')
      ) {
        return '#FFEEA1';
      } else if (
        parseFloat(value) >= parseFloat('300') &&
        parseFloat(value) < parseFloat('500')
      ) {
        return '#FFC298';
      } else if (
        parseFloat(value) >= parseFloat('0') &&
        parseFloat(value) < parseFloat('300')
      ) {
        return '#FC9994';
      } else {
        return '#ffffff';
      }
    } else if (range == 2) {
      if (parseFloat(value) > parseFloat('5000')) {
        return '#9A98FF';
      } else if (
        parseFloat(value) >= parseFloat('4000') &&
        parseFloat(value) < parseFloat('5000')
      ) {
        return '#9BC2FF';
      } else if (
        parseFloat(value) >= parseFloat('3500') &&
        parseFloat(value) < parseFloat('4000')
      ) {
        return '#97F5FD';
      } else if (
        parseFloat(value) >= parseFloat('3000') &&
        parseFloat(value) < parseFloat('3500')
      ) {
        return '#BDFEE1';
      } else if (
        parseFloat(value) >= parseFloat('2500') &&
        parseFloat(value) < parseFloat('3000')
      ) {
        return '#E6FEB6';
      } else if (
        parseFloat(value) >= parseFloat('2000') &&
        parseFloat(value) < parseFloat('2500')
      ) {
        return '#FFEEA1';
      } else if (
        parseFloat(value) >= parseFloat('1500') &&
        parseFloat(value) < parseFloat('2000')
      ) {
        return '#FFC298';
      } else if (
        parseFloat(value) >= parseFloat('0') &&
        parseFloat(value) < parseFloat('1500')
      ) {
        return '#FC9994';
      } else {
        return '#ffffff';
      }
    }
  }

  getCircleMarkerRadius(zoomLevel: number, currentRadius) {
    return currentRadius * zoomLevel * 0.25;
  }

  addTimeBasedLayers(gis, layerList) {
    setTimeout(() => {
      let layerObjPromises = [];
      for (const i in layerList) {
        const layer = layerList[i];
        if (layer['type'] != undefined && layer['type'] == 'Time') {
          const layerObj = this.createLayer(layer, gis);
          layerObj.then((data) => {
            if (data['layer'] != undefined && data['layer'] != null && gis.actualView == layer['serviceType']) {
              if(gis.map.hasLayer(data['layer'])) {
                gis.map.removeLayer(data['layer'])
              } else {
                data['layer'].addTo(gis.map);
                gis.activeLayers.push(data);
                layerList[i] = data;
              }
            }
          });
          layerObjPromises = layerObjPromises.concat(layerObj);
        }
        if (layer['type'] != undefined && layer['type'] == 'Stations') {
          if (layer['layer'] != undefined && layer['layer'] != null && gis.actualView == layer['serviceType']) {
              // layer['layer'].addTo(gis.map); 
            // gis.activeLayers.push(layer);
            if (gis.map.hasLayer(layer['layer'])) {
              gis.map.removeLayer(layer['layer'])
            } 
            // else {
              layer['layer'].addTo(gis.map);
              gis.activeLayers.push(layer);
              layerList[i] = layer;
            // }
            layerObjPromises = layerObjPromises.concat(layer);
          }
        }
      }
      Promise.all(layerObjPromises).then((data) => {
        gis.showThrobber = false;
      });
    }, 2000)
  }

  addSensorLayerForRainfall(gis,layerList) {
    if(gis.actualView != 'Stations')
      return;
    for(let i in layerList) {
      let layer = layerList[i];
      if (layer['type'] != undefined && layer['type'] == 'Stations') {
        if (layer['layer'] != undefined && layer['layer'] != null && gis.actualView == layer['serviceType']) {
            // layer['layer'].addTo(gis.map); 
          // gis.activeLayers.push(layer);
          if (gis.map.hasLayer(layer['layer'])) {
            gis.map.removeLayer(layer['layer'])
          } 
          // else {
            layer['layer'].addTo(gis.map);
            gis.activeLayers.push(layer);
            // layerList[i] = layer;
          // }
        }
      }
    }
  }

  addActualTimeLayers(gis,layerList) {
    for (const i in layerList) {
      const layer = layerList[i];
      if (layer['type'] != undefined && layer['type'] == 'Time' && gis.actualView === layer['serviceType']) {
        // const layerObj = this.createLayer(layer, gis);
        // layerObj.then((data) => {
          if (layer['layer'] != undefined && layer['layer'] != null) {
            // console.log(layer);
            if(!gis.map.hasLayer(layer['layer'])) {
              layer['layer'].addTo(gis.map);
              gis.activeLayers.push(layer);
            }
          }
        //   layerList[i] = data;
        // });
        // layerObjPromises = layerObjPromises.concat(layerObj);
      } else if(layer['type'] != undefined && layer['type'] == 'Stations' && gis.actualView === layer['serviceType']){
        if (layer['layer'] != undefined && layer['layer'] != null) {
          // console.log(layer);
          if(!gis.map.hasLayer(layer['layer'])) {
          layer['layer'].addTo(gis.map);
          gis.activeLayers.push(layer);
          }
        }
        // layerList[i] = layer;
        // layerObjPromises = layerObjPromises.concat(layer);
      }
    }
  }

  removeAllTimeLayers(gis) {
    for (const index in gis.activeLayers) {
      const layer = gis.activeLayers[index];
      if (layer['type'] == 'Time' || layer['type'] == 'Stations') {
        gis.map.removeLayer(layer['layer']);
        gis.activeLayers[index] = 'deleted';
      }
    }
    gis.activeLayers = gis.activeLayers.filter((item) => item != 'deleted');
  }

  removePreviousMarkers() {
    // Initialize or clear the existing LayerGroup
    if (this.LayerGroup) {
      this.LayerGroup.eachLayer((layer) => {
        this.LayerGroup.removeLayer(layer); // Explicitly remove each layer
      }); 
    }
  }

  async setQueryParams(target) {
    // this.mapconstants.isChild = boolean;
    // this.currentApplication = target;
    // console.log(target)
    // let default_Componen_SRC = this.constants.IMD_GRID;
    let default_Componen_SRC = this.constants.CWC;
    let default_Componen_Agg = this.constants.AGGR_TYPES.SUM;

    // this.mapconstants.CurrentApplication = application;
    // this.mapconstants.CurrentComponent = target;
    const params = this.utils.getQueryParamsValue();
    if (params['component'] == undefined || params['component'] != target) {
      let sourcesList = [];
      let sourceUUID = '';
      let bound;

      const postdata = {
        component: target,
        state_uuid: this.stateUUID,
      };
      const defDate = this.utilsShared.getModelDateWithDateFormat(
        new Date(Date.now() - 0 * 24 * 60 * 60 * 1000),
        params['format']
      );
      const bound1 = {
        MIN: defDate,
        MAX: defDate,
      };
      const arr = this.setMinMax(bound1);
      const ytd = this.setYTD(bound1);
      const minDate = arr[0];
      const maxDate = arr[1];
      const Obj = this.utilsShared.setWaterYear(maxDate, minDate);

      const sDate = this.utilsShared.getModelDateWithDateFormat(
        Obj['defaultSDate'],
        this.constants.EVENTGEN_DAY
      );
      const eDate = this.utilsShared.getModelDateWithDateFormat(
        Obj['defaultEDate'],
        this.constants.EVENTGEN_DAY
      );

      sourcesList = await this.observedWeatherDataService
        .getSourceListForComponent(postdata)
        .toPromise();
      let sourceList = [];
      if (sourcesList.length != 0) {
        let index = 0;
        if (target == this.constants.COMPONENTFORROUTING.RAINFALL) {
          // if(sDate == eDate) {
          //   sourcesList.forEach((srcc: any) => {
          //     let obj = srcc
          //     if(srcc['current']==true)
          //       sourceList.push(obj);
          //   })
          // } else {
          sourceList = sourcesList;
          // }
          index = sourcesList.findIndex(
            (src) => src['key'] == this.constants.AP_AWS
          );
          if (index == -1) {
            index = 0;
          }
        } else if (target == this.constants.COMPONENTFORROUTING.TEMPERATURE) {
          // console.log(sourcesList);
          // if (sDate == eDate) {
          //   sourcesList.forEach((srcc: any) => {
          //     const obj = srcc;
          //     if (srcc['current'] == true) {
          //       sourceList.push(obj);
          //     }
          //   });
          // } else {
            sourceList = sourcesList;
          // }
          // index = sourceList.findIndex(src => src['key'] == this.constants.AP_AWS);
          index = sourceList.findIndex(
            (src) => src['key'] == this.constants.STATE_STATIONS
          );
          if (index == -1) {
            index = 0;
          }
        } else if (target == this.constants.COMPONENTFORROUTING.WINDSPEED) {
          if (sDate == eDate) {
            sourcesList.forEach((srcc: any) => {
              const obj = srcc;
              if (srcc['current'] == true) {
                sourceList.push(obj);
              }
            });
          } else {
            sourceList = sourcesList;
          }
          // console.log("index", sourceList)
          index = sourceList.findIndex(
            (src) => src['key'] == this.constants.AP_AWS
          );
          if (index == -1) {
            index = 0;
          }
        } else if (target == this.constants.COMPONENTFORROUTING.HUMIDITY) {
          if (sDate == eDate) {
            sourcesList.forEach((srcc: any) => {
              const obj = srcc;
              if (srcc['current'] == true) {
                sourceList.push(obj);
              }
            });
          } else {
            sourceList = sourcesList;
          }
          // console.log("index", sourceList)
          index = sourceList.findIndex(
            (src) => src['key'] == this.constants.STATE_STATIONS
          );
          if (index == -1) {
            index = 0;
          }
        }
        default_Componen_SRC = sourceList[index]['key'];
        sourceUUID = sourceList[index]['agencyUUID'];
        bound = sourceList[index]['minmax'];
        // console.log('sourcesList[index] ',sourceList[index]);
      }

      // if(this.mapconstants.Component_Default_Agg[this.currentApplication])
      // default_Componen_Agg=this.mapconstants.Component_Default_Agg[this.currentApplication];

      if (default_Componen_SRC) {
        let index = this.constants.COMPONENT_SOURCE_HIERARCHY_MAP[target][
          default_Componen_SRC
        ][this.constants.VIEWS.ADMIN].indexOf(
          this.constants.LOCATION_CONSTANT.COUNTRY
        );
        index =
          index + 1 ==
          this.constants.COMPONENT_SOURCE_HIERARCHY_MAP[target][
            default_Componen_SRC
          ][this.constants.VIEWS.ADMIN].length
            ? index
            : index + 1;
        params['cType'] = this.constants.COMPONENT_SOURCE_HIERARCHY_MAP[target][
          default_Componen_SRC
        ][this.constants.VIEWS.ADMIN][index].toUpperCase();
        // }else if (target == this.constants.COMPONENTFORROUTING.TEMPERATURE){
        //  let  index = sourcesList.findIndex(src => src['key'] == this.constants.SOURCES.IMD_05);
        //   if (index == -1) {
        //     index = 0;
        //   }
      }
      const view = this.constants.VIEWS.ADMIN;

      let format = this.constants.DATEPICKER_DATE_FORMAT.DAY;
      if (target == this.constants.COMPONENT.GROUNDWATER) {
        format = this.constants.DATEPICKER_DATE_FORMAT.SEASON;
      } else if (target == this.constants.COMPONENT.WINDSPEED) {
        default_Componen_Agg = this.constants.AGGR_TYPES.MAX;
        Object.assign(params, {
          locname: this.stateName,
          loctype: this.constants.LOCATION_CONSTANT.STATE,
          locuuid: this.stateUUID,
          mapOnClickParams: false,
          component: target,
          pEUUID: this.stateUUID,
          view,
          src: default_Componen_SRC,
          type: 'ACTUAL',
          aggr: default_Componen_Agg,
          format,
          ytd: ytd['value'],
          chartType: 'stock',
        });
      } else if (target === this.constants.COMPONENT.TEMPERATURE) {
        // format = this.constants.DATE_FORMAT_NEW[format];
        default_Componen_Agg = this.constants.AGGR_TYPES.DEFAULT;
        Object.assign(params, {
          locname: this.stateName,
          loctype: this.constants.LOCATION_CONSTANT.STATE,
          locuuid: this.stateUUID,
          component: target,
          pEUUID: this.stateUUID,
          pUUID: this.stateUUID,
          src: default_Componen_SRC,
          aggr: default_Componen_Agg,
          format,
          chartType: 'stock',
          pType: this.constants.LOCATION_CONSTANT.STATE,
          classification: [this.constants.CLASSIFICATION_TYPES.ACTUAL],
          includeAllLoc: true,
        });
      } else if (target === this.constants.COMPONENT.RAINFALL) {
        Object.assign(params, {
          locname: this.stateName,
          loctype: this.constants.LOCATION_CONSTANT.COUNTRY,
          locuuid: this.stateUUID,
          mapOnClickParams: false,
          component: target,
          pEUUID: this.stateUUID,
          view,
          src: 'IMD_STATIONS',
          type: 'ACTUAL',
          aggr: default_Componen_Agg,
          format: 'yyyyMMdd',
          ytd: ytd['value'],
          chartType: 'stock',
          handleEventFromBreadcrumb: true,
          algo : "IDW"
        });
      } else if (target === this.constants.COMPONENT.HUMIDITY) {
        // format = this.constants.DATE_FORMAT_NEW[format];
        default_Componen_Agg = this.constants.AGGR_TYPES.DEFAULT;
        Object.assign(params, {
          locname: this.stateName,
          loctype: this.constants.LOCATION_CONSTANT.STATE,
          locuuid: this.stateUUID,
          component: target,
          pEUUID: this.stateUUID,
          pUUID: this.stateUUID,
          src: default_Componen_SRC,
          aggr: default_Componen_Agg,
          format,
          chartType: 'stock',
          pType: this.constants.LOCATION_CONSTANT.STATE,
          classification: [this.constants.CLASSIFICATION_TYPES.ACTUAL],
          includeAllLoc: true,
        });
      }
      Object.assign(params, { sDate, eDate });
      // console.log(JSON.parse(JSON.stringify(params)));
      this.utils.setQueryParams(params);
    } else {
      //  console.log("##its same component ##");
    }
  }

  //  getSourceListForComponent(application){
  //   return this.observedWeatherDataService.getSourceListForComponent(application)
  // }

  setYTD(data: object): Object {
    if (!data || !data['MAX'] || data['MAX'] == 0) {
      return;
    }
    const ytd = { required: true };
    ytd['value'] = data['MAX'].toString().substr(0, 4);
    Object.assign(ytd, data);
    // console.log("this.ytd  :::",this.ytd);
    return ytd;
  }

  setMinMax(range: object): any {
    const arr = [];
    if (
      !range ||
      !range['MAX'] ||
      range['MAX'] == 0 ||
      !range['MIN'] ||
      range['MIN'] == 0
    ) {
      const minDate = new Date();
      const maxDate = new Date();
      arr.push(minDate);
      arr.push(maxDate);
      return arr;
    }
    // const minDate = this.utilsShared.getDateObjectFromModelDate(
    //   (range['MIN']).toString()
    // );
    // let maxDate = this.utilsShared.getDateObjectFromModelDate(
    //   range['MAX'].toString()
    // );
    // maxDate = maxDate.getTime() > new Date().getTime() ? new Date() : maxDate;
    let today = new Date();
    let minDate = new Date(today.getFullYear()-1, 10, 17);
    let maxDate = new Date(today); // Clone today's date
    maxDate.setDate(today.getDate() - 1);
    arr.push(minDate);
    arr.push(maxDate);
    return arr;
  }

  // removeAndAddInverseMask(gis, inverseInfo) {
  //   // console.log("Inside Map Service",inverseInfo);
  //   this.removeInverseMaskLayers(gis);
  //   this.addInverseMaskLayer(gis, inverseInfo);
  // }

  // removeInverseMaskLayers(gis) {
  //   for (const index in gis.activeLayers) {
  //     const layer = gis.activeLayers[index];
  //     if (layer['type'] == 'Inverse') {
  //       gis.map.removeLayer(layer['layer']);
  //       gis.activeLayers[index] = 'deleted';
  //     }
  //   }
  //   gis.activeLayers = gis.activeLayers.filter((item) => item != 'deleted');
  // }

  // addInverseMaskLayer(gis, info) {
  //   if (isNullOrUndefined(info)) {
  //     return;
  //   }
  //   for (const index in gis.layerList) {
  //     const layer = gis.layerList[index];
  //     // console.log(layer);
  //     if (
  //       layer['type'] == 'Inverse' &&
  //       layer['name'] == info.name &&
  //       layer['view'] == gis.view
  //     ) {
  //       // console.log("Entered Inverse")
  //       layer['cql_filter'] = info.cql_info;
  //       layer['hidelayer'] = false;
  //       const layerObj = this.createLayer(layer, gis);
  //       if (layerObj['layer'] != undefined && layerObj['layer'] != null) {
  //         layerObj['layer'].addTo(gis.map);
  //         gis.activeLayers = gis.activeLayers.concat(layerObj);
  //       }
  //       gis.layerList[index] = layerObj;
  //     }
  //   }
  // }

  removeAndAddInverseMask(gis, inverseInfo) {
    // console.log("inverseInfo",inverseInfo);
    this.removeInverseMaskLayers(gis);
    this.addInverseMaskLayer(gis, inverseInfo);
  }

  removeInverseMaskLayers(gis) {
    for (const index in gis.activeLayers) {
      const layer = gis.activeLayers[index];
      if (layer['type'] == 'Inverse') {
        gis.map.removeLayer(layer['layer']);
        gis.activeLayers[index] = 'deleted';
      } else if(layer['serviceType'] == 'WmsLayer' && (layer['layerNameType'] == 'DISTRICT' || layer['layerNameType'] == 'BLOCKS') ) {
        gis.map.removeLayer(layer['layer']);
        gis.activeLayers[index] = 'deleted';
      }
    }
    gis.activeLayers = gis.activeLayers.filter(item => item != 'deleted');
  }

  async addInverseMaskLayer(gis, info) {
    if (isNullOrUndefined(info)) {
      for (const index in gis.layerList) {
        const layer = gis.layerList[index];
        if (layer['serviceType'] == 'WmsLayer' && (layer['layerNameType'] == 'DISTRICT' || layer['layerNameType'] == 'BLOCKS')) {
          layer['cql_filter'] = '1=1'
          const layerObj = this.createLayer(layer, gis);
          if (layerObj['layer'] != undefined && layerObj['layer'] != null) {
            layerObj['layer'].addTo(gis.map);
            gis.activeLayers = gis.activeLayers.concat(layerObj);
          }
          gis.layerList[index] = layerObj;
        }
      }
      return
    }
    for (const index in gis.layerList) {
      // console.log("LAYEROBJJgis.layerList::",gis.layerList,index);
      const layer = gis.layerList[index];
      // console.log("LAYEROBJJ::",layer);
      if (layer['type'] == 'Inverse' && layer['name'] == info.name) {
        // console.log('Entered Inverse',layer);
        gis.showThrobber = true
        layer['layerName'] = '';
        layer['layerName'] = 'HEATWAVE:world_view' + ',' + LOCTYPE_LAYER_MAPPING[info['locType']]
        layer['cql_filter'] = info.cql_info;
        layer['hidelayer'] = false;
        const layerObj = this.createLayer(layer, gis);
        if (layerObj['layer'] != undefined && layerObj['layer'] != null) {
          layerObj['layer'].addTo(gis.map);
          gis.activeLayers = gis.activeLayers.concat(layerObj);
        }
        gis.layerList[index] = layerObj;
        layerObj['layer'].on("load", function () {
          gis.showThrobber = false
        })
      } else if(layer['serviceType'] == 'WmsLayer' && (layer['layerNameType'] == 'DISTRICT' || layer['layerNameType'] == 'BLOCKS')){
        layer['cql_filter'] = CQLFILTER_MAPPING[info['locType']][layer['layerNameType']] + '=\'' + info['UUID'] + '\''
        let filter = 'UUID' + '=\''  + info['UUID'] + '\''
        const layerObj = this.createLayer(layer, gis);
        if (layerObj['layer'] != undefined && layerObj['layer'] != null) {
          layerObj['layer'].addTo(gis.map);
          gis.activeLayers = gis.activeLayers.concat(layerObj);
        }
        gis.layerList[index] = layerObj;
        let locType = (info.locType).toUpperCase()
        let geoJSONData = await this.getGeoJSONGeometry(filter,locType)
        let geoData: any = new L.GeoJSON(geoJSONData);
        gis.map.fitBounds(geoData.getBounds())        
      }
    }
  }

  getGeoJSONGeometry(filter:any,locType:any) {
    return new Promise((resolve,reject) => {
      const layerName = MapConstants.GEOSERVER_WORKSPACE_NAME + ':' + ProjConstants.STATE_TO_LAYERTYPE_NAME['ANDHRA PRADESH_' + locType];
          let layerURL = MapConstants.GEOJSON_LAYER_BOUND_URL + '&typeName=' + layerName + '&viewParams=stateName:' + ProjConstants.STATENAME;
          if(filter) {
            layerURL += '&cql_filter=' + filter;
          }
      this.http.get(layerURL).subscribe(
        geoData => {
          resolve(geoData);
        });
    })
  }

  getSensorLayerForRainfall(params,legendData) {
    // return new Promise((resolve, reject) => {
      // let includeAll = layerList['layerOptions']['includeAll'];
      // this.gisMapComp.showThrobber = true
      return new Promise((resolve, reject) => {
        let postData = this.rainfallDataService.getPostDataForSensor(params);
        this.rainfallDataService.post(postData).subscribe(data => {
          //Removing The Previous Markers if any exist.
        this.removePreviousMarkers();
        this.markerLayer = this.LayerGroup; 
        let stationLayer = {
          type: 'Stations',
          serviceType: 'Stations',
        }
        for (var id in data) {
          var info = data[id];
          var newmarker = this.createMarkerForSensorLayer(info, params, legendData, this.mapObj);
          if (newmarker) {
            this.markerLayer.addLayer(newmarker);
          }
        }
        // layers['serviceType'] = 'StationLayer'
        stationLayer['layer'] = this.markerLayer
        // layerList.push(stationLayer);
          resolve(stationLayer);
        })
      });
      // layers.options= this.layerList['layerOptions'];
      // if (!layers) {
      //   layers = this.LayerGroup;
      // } else {
      //   layers.eachLayer((layer) => {
      //     layers.removeLayer(layer);
      //   })
      // }

      // promise1.then((jsonData) => {
      //   var result: any = jsonData;
        // var result: any = data;
        // if (params.compType == 'CAMS_GIS') {
        //   for (var id in result) {
        //     var info = result[id];
        //     if (info.md.dnm == 'Jagtial') {
        //       var newmarker = this.createMarkerForSensorLayer(info, params, legendData, mapObj, deviationMapParams);
        //       if (newmarker)
        //         layers.addLayer(newmarker);
        //     }
        //   }
        //   resolve(layers);
        // } 
        // else {
          // for (var id in result) {
          //   var info = result[id];
          //   var newmarker = this.createMarkerForSensorLayer(info, params, legendData, this.mapObj);
          //   if (newmarker) {
          //     layers.addLayer(newmarker);
          //   }
          // }
          // // layers['serviceType'] = 'StationLayer'
          // stationLayer['layer'] = layers
          // layerList.push(stationLayer);
          // console.log("LAYERS::",layers);
          // this.mapObj.addLayer(stationLayer['layer'])
          // this.gisMapComp.showThrobber = false

          // this.mapObj.on('zoomend', () => {
          //   this.mapObj.removeLayer(stationLayer['layer']);  // Remove existing layer
          //   this.mapObj.addLayer(stationLayer['layer']);     // Add it back to re-align markers
          // });
          // }
        // })
      //   resolve(stationLayer);
      // })
  }

  createMarkerForSensorLayer(data, params, legendData, mapObj) {
    if (data['nm'] === 'TOTAL')
      return;
    // let Radius = 1.75;
    let Radius = 2
    let latLangArray: [number, number];
    let latitude, longitude, rfLevel, timestamp;
    latitude = data['md']['lt'] ? data['md']['lt'] : 0;
    longitude = data['md']['lng'] ? data['md']['lng'] : 0;

    latLangArray = [latitude, longitude];
    // if (params && params['heatMap']['key'] == 'DEVIATION') {
    //   rfLevel = !isNullOrUndefined(data['dl']) ? data['dl'].toFixed(2) : '-';
    // }
    // else {
      rfLevel = data['al'] >= 0 ? data['al'].toFixed(2) : '-';
    // }
    // if(params.timeStep != "HOURLY"){
    //   if (params['sDate'] === params['eDate']) {
    //     timestamp = data.hasOwnProperty('ts') && !isNullOrUndefined(data['ts']) ? moment(data['ts']).format("DD/MM/YYYY HH:mm:ss") : '-';
    //   } else {
    //     timestamp = params.hasOwnProperty('sDate') && params.hasOwnProperty('eDate') && !isNullOrUndefined(params['sDate']) && !isNullOrUndefined(params['eDate']) ? moment(params['sDate']).format("DD/MM/YYYY") + "-" + moment(params['eDate']).format("DD/MM/YYYY") : '-';
    //   }
    // }
    // else {
    //   let currentTimestep = new Date();
    //   let startTimestep = new Date().setHours(8, 30, 0, 0); // Set Time to morning 8:30 
    //   timestamp = moment(startTimestep).format("DD/MM/YYYY HH:mm:ss") + ' - ' +  moment(currentTimestep).format("DD/MM/YYYY HH:mm:ss");
    // }

    if (params['timeStep'] == 'YEARLY') {
      timestamp = params['sDate'] && params['eDate'] ?  params['sDate'] + ' - ' + params['eDate'] : '-';
    }
    else if (params['timeStep'] == 'MONTHLY') {
      // let sdate = params.sDate ? this.rfUtils.getSateliteTimestampLabel(params.sDate.toString()).replace(/^-/, '') : '';
      // let edate = params.eDate ? this.rfUtils.getSateliteTimestampLabel(params.eDate.toString()).replace(/^-/, '') : '';
      // timestamp = sdate && edate ? sdate + ' - ' + edate : '-';
    }
    else if (params['timeStep'] == 'DAILY') {
      // let sdate = params.sDate ? this.rfUtils.getSateliteTimestampLabel(params.sDate.toString()) : '';
      // let edate = params.eDate ? this.rfUtils.getSateliteTimestampLabel(params.eDate.toString()) : '';
      // timestamp = sdate && edate ? sdate + ' - ' + edate : '-';
    }
    else if (params['timeStep'] == 'HOURLY' ){
      let currentTimestep =  new Date().getTime();
      let startTimestep = new Date().setHours(5, 30, 0, 0); // Set Time to morning 8:30 
      // let starthour =  this.rfUtils.convertTimestampToBlockValue(startTimestep);
      // let endhour =  this.rfUtils.convertTimestampToBlockValue(currentTimestep);
      // timestamp = starthour && endhour ? starthour + ' - ' + endhour : '-';
    }
    else {
      timestamp = '-';
    }
    let districtName = !isNullOrUndefined(data['md']) && data.md.hasOwnProperty('dnm') && !isNullOrUndefined(data['md']['dnm']) ? data['md']['dnm'] : '-';
    let mandalName = !isNullOrUndefined(data['md']) && data.md.hasOwnProperty('mnm') && !isNullOrUndefined(data['md']['mnm']) ? data['md']['mnm'] : '-';
    let basinName = data['md'] ? data['md']['bnm'] : '-';
    let stationName = data['nm'] ? data['nm'] : '-';
    var outerCircleOptions = {
      stroke: true,
      fill: true,
      color: "#FF0000",
      weight: 0.55,
      fillColor: "#a3a3a3",
      fillOpacity: 1,
      // radius : 8,
      radius: this.getCircleMarkerRadius(mapObj.getZoom(), Radius),
      interactive: true,
      pane: 'marker'
    };
    var fillColor = this.getFillColor(rfLevel, legendData);
    outerCircleOptions.fillColor = fillColor ? fillColor : '#a3a3a3';
    outerCircleOptions.color = params['timeStep'] == 'YEARLY' ? '#000000' : this.getStrokeColor(params);
    var marker = L.circleMarker(latLangArray, outerCircleOptions);
    var htmlString = "<html><body>";
    htmlString += '<div class="popup-table-section">'
    htmlString += ' <div class="card-body p-0">'
    htmlString += "<table class='table table-sm m-0 table-bordered' >";
    htmlString += '<tbody>'
    htmlString += "<tr><td style='text-transform:uppercase'><span style='text-transform:capitalize' class='text-white'>Station Name</span></td><td style='text-transform:none'  id='station' class='text-white'>" + stationName + "</td></tr>";
    // if (params['view'] == 'ADMIN') {
    //   htmlString += "<tr><td style='text-transform:none'><span style='text-transform:capitalize'> District </span></td><td style=' text-transform:none' id='district'>" + districtName + "</td></tr>";
    //   htmlString += "<tr><td style='text-transform:none'><span style='text-transform:capitalize'> Block </span></td><td style=' text-transform:none' id='mandal'>" + mandalName + "</td></tr>";
    // }
    // else if (params['view'] == VisibilityMapConstants.VIEWS.BASIN)
    //   htmlString += "<tr><td style='text-transform:none'><span style='text-transform:capitalize'> Basin </span></td><td style=' text-transform:none' id='basin'>" + basinName + "</td></tr>";
    // htmlString += "<tr><td style=' text-transform:none'><span style='text-transform:capitalize'>Latitude</span></td><td style='text-transform:none'>" + latitude + "</td></tr>";
    // htmlString += "<tr><td style='text-transform:none'><span style='text-transform:capitalize'>Longitude</span></td><td style='text-transform:none'>" + longitude + "</td></tr>";
    // if (params && params['heatMap']['key'] == 'DEVIATION')
    //   htmlString += "<tr><td style=' text-transform:none'><span style='text-transform:capitalize'>Deviation</span></td><td id='rf' style='text-transform:none'>" + rfLevel + " %</td></tr>";
    // else
      htmlString += "<tr><td style=' text-transform:none'><span style='text-transform:capitalize' class='text-white'>Rainfall Level</span></td><td id='rf' style='text-transform:none' class='text-white'>" + rfLevel + " mm</td></tr>";
    // htmlString += "<tr><td style=' text-transform:none'><span style='text-transform:capitalize'>TimeStamp</span></td><td id='time' style='text-transform:none'>" + timestamp + "</td></tr>";
    htmlString += '<tr></tr>';
    htmlString += "</tbody></table></div></div></body></html>";
    marker.bindPopup("loading...", { autoPan: false, });
    const popup = R.responsivePopup({ hasTip: false, autoPan: false, offset: [0, -1], pane: 'popup', closeButton: true }).setContent(htmlString);
    if (params.compType == 'CAMS_GIS') {
      marker.on({
        mouseover: (e) => {
          // marker.bindPopup(popup).openPopup();
          // marker.setStyle({ color: 'black', weight: 2 });
        },
        mouseout: (e) => {
          // marker.setStyle({ color: outerCircleOptions.color, weight: 0.3 });
          // marker.closePopup();
        },
        click: (e) => {
          marker.bindPopup(popup).openPopup();
          // this.openPopups.push(popup);
          params['locName'] = stationName;
          params['pUUID'] = data['uid']
          params['pType'] = 'RAINFALL',
            params['cType'] = 'RAINFALL',
            params['actionType'] = 'sensorClick'
          // this.utilsSrv.setSelectedParams(params);
        }
      });
    } else {
      marker.on({
        mouseover: (e) => {
          marker.bindPopup(popup).openPopup();
          marker.setStyle({ color: 'black', weight: 2 });
        },
        mouseout: (e) => {
          marker.setStyle({ color: outerCircleOptions.color, weight: 0.3 });
          marker.closePopup();
        },
        click: (e) => {
          // marker.bindPopup(popup).openPopup();
          popup.setContent(htmlString).setLatLng(e.target.getLatLng()).addTo(mapObj);
          // this.openPopups.push(popup);
          // marker.setStyle({ color: 'black', weight: 2 });
          params['locName'] = stationName;
          params['pUUID'] = data['uid']
          params['pType'] = 'RAINFALL',
            params['cType'] = 'RAINFALL',
            params['actionType'] = 'sensorClick'
          // this.utilsSrv.setSelectedParams(params);
        },
      });
    }


    //MOBILE VIEW CLICK PROPERTY
    if (L.Browser.mobile) {
      let isPopupOpen = 0;
      marker.on({
        click: (e) => {
          // const popup = R.responsivePopup({ hasTip: true, autoPan: false, offset: [1, 2] }).setContent(htmlString);
          // this.openPopups.push(popup);
          // marker.bindPopup(popup).openPopup();
          // marker.setStyle({ color: 'black', weight: 2 });
          // params['locName'] = stationName;
          // params['pUUID'] = data['uid']
          // params['pType'] = 'RAINFALL',
          //   params['cType'] = 'RAINFALL',
          //   params['actionType'] = 'sensorClick'
          // this.utilsSrv.setSelectedParams(params);
          // isPopupOpen = 1;
        }
      })

      marker.on('popupclose', function () {
        if (isPopupOpen) {
          marker.setStyle({ color: 'black', weight: 1 });
        }
      });

    }

    if (!isNullOrUndefined(mapObj)) {
      let initialZoom = mapObj.getZoom();
      mapObj.on({
        zoomend: (e: L.LeafletEvent) => {
          let currentZoom = mapObj.getZoom();
          let diff = currentZoom - initialZoom;

          if (diff > 0)
            marker.setRadius(this.getCircleMarkerRadius(currentZoom, 2))
          else if (diff < 0)
            marker.setRadius(this.getCircleMarkerRadius(currentZoom, Radius - 0.25))
          else
            marker.setRadius(this.getCircleMarkerRadius(currentZoom, Radius));
        }
      })
    }
    return  marker;
  }
  
  getFillColor(rainfallLevel, legendData) {
    // rainfallLevel = parseFloat(rainfallLevel);
    let lev;
    if (!isNullOrUndefined(legendData) && legendData.hasOwnProperty('colorValues')) {
      Object.keys(legendData.colorValues).forEach(item => {
        let obj = legendData.colorValues[item];
        let value = obj.text;
        if (value.includes('-')) {
          let array = value.split("-");
          if (rainfallLevel >= Number(array[0]) && rainfallLevel <= Number(array[1])) {
            lev = obj.backgroundColor
          }
        } else if (value.includes('>')) {
          let array = value.split(">");
          if (rainfallLevel > Number(array[1])) {
            lev = obj.backgroundColor
          }
        }
      })
    }
    return lev;
  }

  getStrokeColor(params, deviationMapParams?) {
    // let dateRange = this.rfUtils.getNoOfDaysBetweenTwoEventGenDay(params['sDate'], params['eDate']);

    // if (deviationMapParams && deviationMapParams['heatMap']['key'] == VisibilityMapConstants.HEATMAP.DEVIATION) {
    //   if (dateRange < 5)
    //     return '#37D934';
    //   if (dateRange >= 5 && dateRange < 10)
    //     return '#E9F029';
    //   if (dateRange >= 10 && dateRange < 20)
    //     return '#E9F029';
    //   if (dateRange >= 20 && dateRange < 30)
    //     return '#09D0DE';
    //   if (dateRange >= 30 && dateRange < 40)
    //     return '#09D0DE';
    //   else
    //     return '#0D65D1';
    // }
    // else {
        return '#000000';
    // }
  }
}

